export default "__VITE_ASSET__DuvdD8$M__"